<template>
  <div>
    <form class="form-inline ml-3">
      <label class="my-1 mr-2" for="inlineFormInputName2">Room Filter</label>
      <input type="text" class="form-control my-1 mr-sm-2" style="width:500px" id="inlineFormInputName2" placeholder="Room" v-model="search">
      <button type="submit" class="btn btn-primary my-1 mr-sm-2" @click.prevent="filter(search)"> Filter</button>
    </form>
    <ul class="sessions">

      <router-link v-for="(sval, skey) in filteredSessions" :key="skey" :to="'/days/' + $route.params.day + '/' + sval.id">
        <li>
          <table>
            <tbody>
            <tr>
              <td>Time</td>
              <td>{{ sval.start_time }} &ndash; {{ sval.end_time }}</td>
            </tr>
            <tr>
              <td>Room</td>
              <td>{{ sval.room.name }}</td>
            </tr>
            <tr v-if="sval.session_group">
              <td>Group</td>
              <td>{{ sval.session_group.name }}</td>
            </tr>
            <tr class="type" v-if="sval.session_type">
              <td>Type</td>
              <td>
                <span class="type" :style="{ color: sval.session_type.value.color, background: sval.session_type.value.background }">
                  {{ sval.session_type.name }}
                </span>
              </td>
            </tr>
            <tr class="title">
              <td>Title</td>
              <td>
                <b>{{ sval.code }} {{ sval.title }}</b>
              </td>
            </tr>
            <tr class="title" v-if="sval.content && sval.content.comment">
              <td>Comment</td>
              <td>
                <b style="color:red">{{ sval.content.comment }} </b>
              </td>
            </tr>
            </tbody>
          </table>
          <span class="arrow">
            <font-awesome-icon :icon="['fas', 'angle-right']"/>
          </span>
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
import {mapState,mapMutations, mapActions} from 'vuex'

export default {
  data() {
    return {
      search: '',
      filtered: {}
    }
  },
  computed: {
    ...mapState(['days', 'sessions', 'activeFilter']),
    filteredSessions: function () {
      return Object.keys(this.filtered).length > 0 ? this.filtered : this.sessions;
    }

  },
  methods: {
    ...mapActions(['getSessions']),

    ...mapMutations(['setActiveFilter']),

    filter(term) {
      if(term.length > 0) {

        this.setActiveFilter(term)

        const objFilter = (obj, condition) => {
          let newObj = {}
          for (const [key, value] of Object.entries(obj)) {
            if (condition(value)) {
              newObj = {...newObj, [key]: value}
            }
          }
          return newObj
        }
        this.filtered = objFilter(this.sessions, (value) => value.room.name.toLowerCase() == term.toLowerCase());
      }else{
        this.filtered = {};
        this.setActiveFilter(term)
      }

    }

  },
  async created() {
    await this.getSessions({id: this.$route.params.day});
    if(this.activeFilter){
      console.log(this.activeFilter)
      this.search = this.activeFilter;
      this.filter(this.search)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/colors';

.sessions {
  padding: 0;
  margin: 0;

  > a {
    > li {
      list-style: none;
      padding: 12px 16px 12px 16px;
      border-bottom: 1px solid #e4e4e4;
      position: relative;
      white-space: nowrap;

      > table {
        border: 0;
        border-spacing: 0;
        border-collapse: collapse;

        > tbody {
          > tr {
            > td {
              padding: 2px 0;

              &:first-child {
                width: 150px;
              }

              > .type {
                display: inline-block;
                margin-left: -2px;
                padding: 3px 2px 2px 2px;
                border-radius: 3px;
              }
            }

            &.type > td {
              padding: 0;
            }

            &.title > td {
              padding-top: 10px;
            }
          }
        }
      }

      > .arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-13px);
        right: 16px;
        display: inline-block;
        height: 100%;
        font-size: 24px;
        opacity: .3;
      }
    }

    &:hover {
      text-decoration: none;

      > li {
        background: lighten($conference-color, 95%);

        .arrow {
          opacity: 1;
        }
      }
    }
  }
}
</style>
